<template>
    <div class="animated fadeIn">
        <table class="area">
            <tr>
                <td v-for="x in [0,1,2]" style="">
                    <img :src="images[next[x]]" alt="">
                </td>
            </tr>
        </table>
        <br><br>
        <table class="area">
            <tr v-for="y in range08">
                <td v-for="x in range08" style=""  @click="onClick"  :ref="'r'+x+y" :data-x="x" :data-y="y" :class="'xx'+available[y][x]">
                    <img :src="images[state[y][x]]" alt="" v-if="state[y][x]" :class="getClass(y,x)">
                </td>
            </tr>
        </table>
        <br><br>
        <button class="btn btn-primary" @click="newGame()">Новая игра</button>
        <br><br>
        active:{{active}}<br>
        score:{{score}}<br>
        lastRemoved:{{lastRemoved}}<br>
        totalRemoved:{{totalRemoved}}<br>
        lastScore:{{lastScore}}<br>
        totalScore:{{totalScore}}<br>


        toBeRemoved: <span v-for="p in toBeRemoved">{ {{p.y}},{{p.x}} }</span>
    </div>
</template>

<script>
    import Vue from 'vue'

    import {CONSTANTS} from '@/constants';

    const Q = 9;
    const M = 5;

    export default {
        name: 'Dummy',
        data: function () {
            return {
                active:null,
                images: [
                    null,
                    'img/lines/blue.png',
                    'img/lines/brown.png',
                    'img/lines/green.png',
                    'img/lines/navy.png',
                    'img/lines/pink.png',
                    'img/lines/red.png',
                    'img/lines/yellow.png',
                ],
                range08: [0,1,2,3,4,5,6,7,8],
                state: [
                    [1,2,3,4,5,6,7,0,0],
                    [0,0,0,0,0,0,0,0,0],
                    [0,1,1,0,0,0,2,2,2],
                    [1,0,0,1,0,2,0,0,0],
                    [1,0,0,1,0,0,2,2,0],
                    [1,1,1,1,0,0,0,0,2],
                    [1,0,0,1,0,2,2,2,0],
                    [0,0,0,0,0,0,0,0,0],
                    [0,0,0,0,0,0,0,0,0],
                ],
                available: [
                    [0,0,0,0,0,0,0,0,0],
                    [0,0,0,0,0,0,0,0,0],
                    [0,0,0,0,0,0,0,0,0],
                    [0,0,0,0,0,0,0,0,0],
                    [0,0,0,0,0,0,0,0,0],
                    [0,0,0,0,0,0,0,0,0],
                    [0,0,0,0,0,0,0,0,0],
                    [0,0,0,0,0,0,0,0,0],
                    [0,0,0,0,0,0,0,0,0],
                ],
                tout:null,
                next:[0,0,0],
                score:0,
                lastRemoved:0,
                totalRemoved:0,
                lastScore:0,
                totalScore:0,
                toBeRemoved:[]
            }
        },
        methods: {
            onClick: function(e) {
                let t = e.currentTarget;
                let y = parseInt(t.getAttribute('data-y'));
                let x = parseInt(t.getAttribute('data-x'));
                if (this.state[y][x]) {
                    this.active = { x:x, y:y };
                    this.calcAvailable();
                }
                else {
                    if ((this.active !== null) && this.available[y][x])  {
                        this.state[y][x] = this.state[this.active.y][this.active.x];
                        this.state[this.active.y][this.active.x] = 0;
                        this.checkLine(y, x);
                        this.active = null;
                        this.stopPlaySound();
                        this.placeNextRandom3();
                    }
                }
            },
            isActive: function(y, x) {
                if (this.active===null) return false;
                return ((this.active.y===y)&&(this.active.x===x));
            },
            willBeRemoved: function(y, x) {
                for (let i=0; i<this.toBeRemoved.length; i++) {
                    if ((this.toBeRemoved[i].x === x)&&(this.toBeRemoved[i].y === y)) {
                        return true;
                    }
                }
                return false;
            },
            getClass: function(y, x) {
                if (this.willBeRemoved(y, x)) {
                    return 'rem';
                }
                if (this.isActive(y, x)) {
                    return 'act';
                }
                return '';
            },
            playSound: function () {
                this.tout = setTimeout(this.playSound, 600);
                if (this.active!==null) {
                    let ballSound = new Audio('img/lines/ball.wav');
                    //ballSound.play();
                }
            },
            stopPlaySound: function() {
                clearTimeout(this.tout);
            },
            setNextRandom3: function () {
                for (let i=0; i<3; i++) {
                    this.next[i] = Math.floor(Math.random() * 1) + 1;
                }
            },
            placeNextRandom3: function () {
                for (let i=0; i<3; i++) {
                    let pos = this.getRandomFreeSlot();
                    if (pos!==null) {
                        this.state[pos.y][pos.x] = this.next[i];
                        this.checkLine(pos.y, pos.x);
                    }
                    else {
                        this.stopGame();
                    }
                }
                this.setNextRandom3();
            },
            stopGame: function () {

            },
            getRandomFreeSlot: function () {
                let pos = {
                    x: Math.floor(Math.random() * Q),
                    y: Math.floor(Math.random() * Q)
                };
                let sp = Object.assign({}, pos);
                while (this.state[pos.y][pos.x]) {
                    pos.x ++;
                    if (pos.x===Q) { pos.y++; pos.x = 0;}
                    if (pos.y===Q) { pos.y = 0;}
                    if ((pos.y === sp.y)&&(pos.x===sp.x)) { return null; }
                }
                //console.log(pos,sp)
                return pos;
            },
            calcAvailable: function () {
                for (let y=0; y<Q; y++) {
                    for (let x=0; x<Q; x++) {
                        this.available[y][x] = this.state[y][x] > 0 ? 1 : 0;
                    }
                }
                this.markNeighbours(this.active.y, this.active.x)
            },
            markNeighbours(y, x) {
                //console.log(y,x)
                if (x>0 && !this.available[y][x-1]) {
                    this.available[y][x-1] = 2;
                    this.markNeighbours(y,x-1)
                }
                if (y>0 && !this.available[y-1][x]) {
                    this.available[y-1][x] = 2;
                    this.markNeighbours(y-1,x)
                }
                if (x<Q-1 && !this.available[y][x+1]) {
                    this.available[y][x+1] = 2;
                    this.markNeighbours(y,x+1)
                }
                if (y<Q-1 && !this.available[y+1][x]) {
                    this.available[y+1][x] = 2;
                    this.markNeighbours(y+1,x)
                }
            },
            newGame: function () {
                console.log('newGame')
                this.score = 0;
                this.lastRemoved = 0;
                this.totalRemoved = 0;
                this.lastScore = 0;
                this.totalScore = 0;
                for (let y=0; y<Q; y++) {
                    for (let x=0; x<Q; x++) {
                        this.state[y][x] = 0;
                    }
                }
                this.$forceUpdate();
                this.setNextRandom3();
                this.placeNextRandom3();
            },
            checkLine:function(y0, x0) {
                console.log('checkLine('+y0+','+x0+')')
                this.available[y0][x0] = 3;
                let cnt = [0,0,0,0];
                let pnt = [[],[],[],[]];

                for (let x=x0+1;x<Q;x++) {
                    if (this.state[y0][x]===this.state[y0][x0]) {
                        this.available[y0][x] = 4;
                        cnt[0]++;
                        pnt[0].push({y:y0,x:x});
                    }
                    else break;
                }
                for (let x=x0-1;x>=0;x--) {
                    if (this.state[y0][x]===this.state[y0][x0]) {
                        this.available[y0][x] = 4;
                        cnt[0]++;
                        pnt[0].push({y:y0,x:x});
                    }
                    else break;
                }
                for (let y=y0+1;y<Q;y++) {
                    if (this.state[y][x0]===this.state[y0][x0]) {
                        this.available[y][x0] = 5;
                        cnt[1]++;
                        pnt[1].push({y:y,x:x0});
                    }
                    else break;
                }
                for (let y=y0-1;y>=0;y--) {
                    if (this.state[y][x0]===this.state[y0][x0]) {
                        this.available[y][x0] = 5;
                        cnt[1]++;
                        pnt[1].push({y:y,x:x0});
                    }
                    else break;
                }
                for (let y=y0+1,x=x0+1;y<Q&&x<Q;y++,x++) {
                    if (this.state[y][x]===this.state[y0][x0]) {
                        this.available[y][x] = 6;
                        cnt[2]++;
                        pnt[2].push({y:y,x:x});
                    }
                    else break;
                }
                for (let y=y0-1,x=x0-1;y>=0&&x>=0;y--,x--) {
                    if (this.state[y][x]===this.state[y0][x0]) {
                        this.available[y][x] = 6;
                        cnt[2]++;
                        pnt[2].push({y:y,x:x});
                    }
                    else break;
                }
                for (let y=y0+1,x=x0-1;y<Q&&x>=0;y++,x--) {
                    if (this.state[y][x]===this.state[y0][x0]) {
                        this.available[y][x] = 7;
                        cnt[3]++;
                        pnt[3].push({y:y,x:x});
                    }
                    else break;
                }
                for (let y=y0-1,x=x0+1;y>=0&&x<Q;y--,x++) {
                    if (this.state[y][x]===this.state[y0][x0]) {
                        this.available[y][x] = 7;
                        cnt[3]++;
                        pnt[3].push({y:y,x:x});
                    }
                    else break;
                }

                let _toBeRemoved = [];
                for (let i=0; i<4;i++) {
                    if (cnt[i]>=M-1) {
                        console.log('remove line=', i)
                        _toBeRemoved = _toBeRemoved.concat(pnt[i]);
                        console.log('_toBeRemoved', _toBeRemoved)
                    }
                }

                if (_toBeRemoved.length>0) {
                    _toBeRemoved.push({x:x0,y:y0});
                    console.log('_toBeRemoved', _toBeRemoved)
                    console.log('this.toBeRemoved 1', this.toBeRemoved)
                    for (let i=0; i<_toBeRemoved.length;i++) {
                        this.toBeRemoved.push(_toBeRemoved[i]);
                    }
                    console.log('this.toBeRemoved 2', this.toBeRemoved)
                    this.lastRemoved = _toBeRemoved.length;
                    this.totalRemoved += _toBeRemoved.length;
                    this.lastScore = this.calcScore(_toBeRemoved.length);
                    this.totalScore += this.lastScore;
                }

                setTimeout(this.remove, 300);
                //this.remove();
            },
            remove: function () {
                console.log('remove')
                console.log('this.toBeRemoved', this.toBeRemoved)
                for (let i=0; i<this.toBeRemoved.length;i++) {
                    this.state[this.toBeRemoved[i].y][this.toBeRemoved[i].x] = 0;
                }
                this.toBeRemoved = [];
            },
            calcScore: function (n) {
                if (n<M) return 0;
                let m = 5;
                return m*2;
            }
        },
        computed: {

        },
        created: function() {
            this.playSound();
            this.setNextRandom3();
        },
        mounted: function () {

        }
    }
</script>

<style type="text/css">
    .area td {
        position:relative;
        width:50px;
        height:50px;
        padding:3px;
        margin:2px;
        border: outset 4px #CCC;
    }
    .act {
        width:40px;
        position:absolute;
        left:3px;
        animation: animate-ball 0.6s ease infinite;
    }
    @keyframes animate-ball {
        0% {
            height:40px;
            top:0px;
        }
        50% {
            height:24px;
            top:22px;
        }
        100% {
            height:40px;
            top:0px;
        }
    }
    .rem {
        width:40px;
        position:absolute;
        left:3px;
        animation: animate-ball 0.1s ease infinite;
    }
    .xx0 {
        //background-color: #00a0d2;
    }
    .xx1 {
        //background-color: #dc3232;
    }
    .xx2 {
        //background-color: #008000;
    }
    .xx3 {
    //background-color: #808080;
    }
    .xx4 {
    //background-color: #008080;
    }
    .xx5 {
    //background-color: #800080;
    }
    .xx6 {
    //background-color: #808000;
    }
    .xx7 {
    //background-color: #000080;
    }

</style>
